import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { Http } from '@angular/http';

@Injectable()
export class BeneficiariosService {
  
  private service_url;

  constructor(
    private constantsService: ConstantsService, 
    private http: Http,
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService
  ) { 
    this.service_url = this.constantsService.apiURL + '/fondeadores/registro-fondeador';
  }

    //Validación del form para registrar beneficiario
    public validate(data){
      console.log("validating... ", data);
      
      let error = [];
  
      if(!this.validatorService.required(data["nombre_b1"])){
        error["nombre_b1"] = this.errorService.required;
      }
      
      if(!this.validatorService.required(data["telefono_b1"])){
          error["telefono_b1"] = this.errorService.required;
      }
  
      // validacion de EMAIL
      if(!this.validatorService.required(data["email_b1"])){
        error["email_b1"] = this.errorService.required;
      }
      else if(!this.validatorService.max(data["email_b1"], 40)){
        error["email_b1"] = this.errorService.max(40);
      }
      else if (!this.validatorService.email(data['email_b1'])) {
        error['email_b1'] = this.errorService.email;
      }
      
      return error;
    }
    public saveBeneficiario(data) {
      return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
    }

    public getBeneficiarios(){
      return this.http.get(this.service_url+"/beneficiarios?", this.authService.getAuthHeaders());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/beneficiarios.service.ts